import React, { useState, useEffect } from "react";
import { Menu, ShoppingCart, User, X, Trash } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "./CartContext";
import Logo from "../Assest/images/Rayaness.png";
import dummyPic from "../Assest/images/Second.jpg";
import getSymbolFromCurrency from 'currency-symbol-map';
import CountryCurrencyDropdown from "./Country";
import { useCurrency } from "./CurrencyContext";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const { cart, removeFromCart, clearCart } = useCart();
  const navigate = useNavigate();
  const [hasToken, setHasToken] = useState(null)

  const { rate, currency } = useCurrency();

  const convertPrice = (price) => {
    const productPrice = parseFloat(price) || 0;
    const convertedPrice = productPrice * rate;
    return convertedPrice
  }
  const currencySymbol = currency === "SAR" ? "﷼" : getSymbolFromCurrency(currency) || currency;

  useEffect(() => {
    const registeredToken = sessionStorage.getItem("token") !== null;
    const guestOrderToken = sessionStorage.getItem("guestOrderToken") !== null;

    if (registeredToken) {
      setHasToken(registeredToken);
    } else if (guestOrderToken) {
      setHasToken(guestOrderToken);
    } else {
      setHasToken(null);
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen || cartOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen, cartOpen]);

  const handleCheckout = () => {
    // clearCart();
    setCartOpen(false);
    navigate("/checkout", { state: { cart } });
  };

  const calculateSubtotal = () => {
    return cart
      .reduce(
        (total, item) =>
          total + (parseFloat(item.price) * (item.quantity || 1)),
        0
      )
      .toFixed(2);
  };

  // Navigation Links Array
  const navLinks = ["Home", "Product", "About us", "Contact"];

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      {/* Announcement Bar with Gradient */}
      <div className="relative w-full bg-gradient-to-r from-orange-600 via-orange-500 to-orange-600 text-white py-3 overflow-hidden">
        <marquee className="text-sm font-semibold">
          ⚡ Special Offer: Get 50% Off on Your First Purchase! Free Shipping on Orders Over $99 | Hurry, Limited Time Only! | Shop Now and Save Big! 🚀
        </marquee>
      </div>

      {/* Main Navigation */}
      <nav className="w-full bg-white text-gray-800  border-b border-gray-100 backdrop-blur-sm bg-opacity-95 sticky top-0
        shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 sm:h-20">
            {/* Logo */}
            <div className="flex-shrink-0 flex items-center">
              <Link to="/" className="flex items-center space-x-2 sm:space-x-3">
                <img
                  src={Logo}
                  alt="Rayane Logo"
                  className="h-8 w-8 sm:h-10 sm:w-10 object-contain"
                />
                <span className="text-xl sm:text-2xl font-bold text-gray-900">
                  Rayane.
                </span>
              </Link>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-8">

              {navLinks.map((link) => (
                <Link
                  key={link}
                  to={
                    link === "Home"
                      ? "/"
                      : `/${link.toLowerCase().replace(" ", "")}`
                  }
                  className="text-gray-600 hover:text-orange-600 px-3 py-2 text-sm font-medium transition-colors relative group"
                >
                  {link}
                  <span className="absolute bottom-0 left-0 w-full h-0.5 bg-orange-600 transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
                </Link>
              ))}

            </div>


            {/* Right Section */}
            < div className="flex items-center space-x-4 sm:space-x-6">
              {/* CountryCurrencyDropdown */}
              <div className="hidden md:block">
                <div className="w-[250px] sm:w-[200px] lg:w-[150px]">
                  <CountryCurrencyDropdown />
                </div>
              </div>

              {/* Auth Buttons - Desktop */}
              {!hasToken && (
                <div className="hidden lg:flex items-center space-x-4">
                  <Link
                    to="/login"
                    className="text-gray-600 hover:text-orange-600 px-3 py-2 text-sm font-medium transition-colors"
                  >
                    Login
                  </Link>
                  <Link
                    to="/signup"
                    className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-full text-sm font-medium transition-colors"
                  >
                    Sign Up
                  </Link>
                </div>
              )}


              {/* User Icon - Only when authenticated */}
              {hasToken && (
                <Link
                  to="/profile"
                  className="text-gray-600 hover:text-orange-600 transition-colors"
                >
                  <User className="h-6 w-6" />
                </Link>
              )}

              {/* Cart Icon */}
              <button
                onClick={() => setCartOpen(true)}
                className="text-gray-600 hover:text-orange-600 transition-colors relative"
              >
                <ShoppingCart className="h-6 w-6" />
                {cart.length > 0 && (
                  <span className="absolute -top-2 -right-2 bg-orange-600 text-white text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full">
                    {cart.length}
                  </span>
                )}
              </button>

              {/* Mobile Menu Button */}
              <button
                onClick={() => setMenuOpen(true)}
                className="lg:hidden text-gray-600 hover:text-orange-600 transition-colors"
              >
                <Menu className="h-6 w-6" />
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity duration-300 ${menuOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        onClick={() => setMenuOpen(false)}
      >
        <div
          className={`fixed top-0 left-0 bottom-0 w-[280px] bg-white transform transition-transform duration-300 ease-out ${menuOpen ? "translate-x-0" : "-translate-x-full"
            }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-col h-full">
            {/* Mobile Menu Header */}
            <div className="p-4 border-b border-gray-200 flex justify-between items-center">
              <span className="text-lg font-semibold text-gray-900">Menu</span>
              <button
                onClick={() => setMenuOpen(false)}
                className="text-gray-500 hover:text-orange-600 transition-colors"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            {/* Mobile Navigation Links */}
            <div className="flex-1 overflow-y-auto">
              <div className="py-2">
                {navLinks.map((link) => (
                  <>
                    <Link
                      key={link}
                      to={
                        link === "Home"
                          ? "/"
                          : `/${link.toLowerCase().replace(" ", "")}`
                      }
                      className="block px-4 py-3 text-base font-medium text-gray-600 hover:bg-orange-50 hover:text-orange-600 transition-colors"
                      onClick={() => setMenuOpen(false)}
                    >
                      {link}
                    </Link>
                    <hr className="border-gray-300" />
                  </>
                ))}
              </div>
              <div className="p-5 md:hidden ">
                <div className="w-full">
                  <CountryCurrencyDropdown />
                </div>
              </div>
            </div>

            {/* Mobile Auth Buttons */}
            {!hasToken && (
              <div className="p-4 border-t border-gray-200">
                <div className="grid grid-cols-2 gap-3">
                  <Link
                    to="/login"
                    className="text-center py-2.5 text-sm font-medium text-gray-600 hover:text-orange-600 border border-gray-200 rounded-lg transition-colors"
                    onClick={() => setMenuOpen(false)}
                  >
                    Login
                  </Link>
                  <Link
                    to="/signup"
                    className="text-center py-2.5 text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 rounded-lg transition-colors"
                    onClick={() => setMenuOpen(false)}
                  >
                    Sign Up
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Cart Sidebar */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity duration-300 ${cartOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        onClick={() => setCartOpen(false)}
      >
        <div
          className={`fixed top-0 right-0 bottom-0 w-full sm:w-[400px] bg-white transform transition-transform duration-300 ease-out ${cartOpen ? "translate-x-0" : "translate-x-full"
            }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-col h-full">
            {/* Cart Header */}
            <div className="p-4 border-b border-gray-200 flex justify-between items-center">
              <span className="text-lg font-semibold text-gray-900">
                Your Cart
              </span>
              <button
                onClick={() => setCartOpen(false)}
                className="text-gray-500 hover:text-orange-600 transition-colors"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            {/* Cart Items */}
            <div className="flex-1 overflow-y-auto p-4">
              {cart.length > 0 ? (
                <div className="space-y-4">
                  {cart.map((item, index) => (
                    <div
                      key={index}
                      className="flex gap-4 p-3 bg-gray-50 rounded-lg"
                    >
                      <img
                        src={`${process.env.REACT_APP_API_URI}/uploads/${item.image}` || dummyPic}
                        alt={item.name || item.product_name}
                        className="w-20 h-20 object-cover rounded-md"
                      />
                      <div className="flex-1">
                        <h3 className="font-medium text-gray-900">
                          {item.name || item.product_name}
                        </h3>
                        <h3 className="font-medium text-gray-900">
                          {item.name || item.selectedSize}
                        </h3>
                        <div className="mt-1 flex flex-wrap gap-2">
                          {/* <span className="text-sm text-gray-600">
                            Size: {item.selectedSize}
                          </span>
                          <span className="text-sm text-gray-600">
                            Color: {item.selectedColor}
                          </span> */}
                          <span className="text-sm text-gray-600">
                            Quantity: {item.quantity}
                          </span>
                        </div>
                        <div className="mt-2 flex justify-between items-center">
                          <span className="font-medium text-gray-900">
                            {currencySymbol} {convertPrice(item.price).toFixed(2)}
                          </span>
                          <button
                            onClick={() => removeFromCart(item.product_id)}
                            className="text-red-500 hover:text-red-600 transition-colors"
                          >
                            <Trash className="h-5 w-5" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="h-full flex flex-col items-center justify-center text-center">
                  <ShoppingCart className="h-12 w-12 text-gray-400 mb-4" />
                  <p className="text-gray-600 font-medium">
                    Your cart is empty
                  </p>
                  <p className="text-gray-400 text-sm mt-1">
                    Add items to your cart to proceed with checkout
                  </p>
                </div>
              )}
            </div>

            {/* Cart Footer */}
            {cart.length > 0 && (
              <div className="p-4 border-t border-gray-200">
                <div className="space-y-3">
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600">Subtotal</span>
                    <span className="font-medium text-gray-900">
                      {currencySymbol} {convertPrice(calculateSubtotal()).toFixed(2)}
                    </span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600">Shipping</span>
                    <span className="font-medium text-gray-900">
                      Calculated at checkout
                    </span>
                  </div>
                  <div className="flex justify-between text-base font-medium pt-2 border-t">
                    <span className="text-gray-900">Total</span>
                    <span className="text-gray-900">
                      {currencySymbol} {convertPrice(calculateSubtotal()).toFixed(2)}
                    </span>
                  </div>
                  <button
                    onClick={handleCheckout}
                    className="w-full bg-orange-600 text-white py-3 rounded-lg font-medium hover:bg-orange-700 transition-colors"
                  >
                    Proceed to Checkout
                  </button>
                  <button
                    onClick={() => setCartOpen(false)}
                    className="w-full text-gray-600 hover:text-gray-800 transition-colors text-sm font-medium"
                  >
                    Continue Shopping
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
